import _ from 'lodash'
import request from '@/utils/request'

const prefix = '/django_rest/client-admin/upload-resume-data'

export default {
  uploadData (params) {
    const formData = new FormData()
    _.forEach(params, (value, key) => {
      if (value !== null && value !== undefined) {
        formData.append(key, value)
      }
    })
    return request.post(`${prefix}/`, formData)
  },
  getUploadDataStatusInfo (params) {
    return request.get(`${prefix}/`, { params })
  }
}
